import { z } from 'zod';
import { checkReportRange, reportRangeShape, withRangeDefaults } from './report.schema.js';
import { flowLevelSchema, flowTotalsSchema } from './flow.schema.js';
/**
 * BITTA TUGUNNING DETALI — «nima bo'ldi?» degan savolning javobi.
 *
 * Jadval «qancha» ga javob beradi: korxonada 12 kirim, 7 rasxod. Keyingi
 * savol esa darhol keladi va u boshqa savol — NIMA kirdi, NIMA chiqdi,
 * kim javondan olib ketdi va qaysi hujjat bilan. Jadvalga ustun qo'shib
 * javob berib bo'lmaydi: bu yerda ro'yxatlar bor, ustun esa bitta
 * qiymat.
 *
 * Shuning uchun alohida so'rov va alohida panel. Daraja AHAMIYATSIZ —
 * MTU dan ichki omborgacha javob bir xil shaklda keladi, faqat qamrov
 * boshqa: MTU da butun mintaqa, ichki omborda bitta javon.
 */
/** So'rov `level` + `id` — bu TUGUNNING O'ZI, otasi emas. */
export const flowDetailQuerySchema = z
    .object({
    ...reportRangeShape,
    level: flowLevelSchema,
    id: z.string().regex(/^\d+$/, 'Noto\'g\'ri identifikator'),
})
    .transform(withRangeDefaults)
    .superRefine(checkReportRange);
/**
 * Ro'yxatlarning uzunligi.
 *
 * Panel — javob emas, YO'LLANMA: u eng kattasini ko'rsatadi va qolgani
 * uchun o'z bo'limiga yuboradi. Uzun ro'yxat panelni ichidan
 * siljiydigan ikkinchi sahifaga aylantirardi.
 */
export const FLOW_DETAIL_TOP = 6;
export const FLOW_DETAIL_ROWS = 10;
/**
 * Nomenklatura kesimi — miqdor O'Z BIRLIGI bilan.
 *
 * Mahsulotlar bo'yicha yig'ish mumkin, tugun bo'yicha esa yo'q: 4 dona
 * qo'lqop va 18 metr kabel «22» bo'lmaydi.
 */
export const flowProductSchema = z.object({
    nomenclatureId: z.string(),
    name: z.string(),
    unit: z.string(),
    qty: z.number(),
    /** Shu mahsulot nechta HUJJATDA uchragani — «bir marta ko'p oldi» va
        «har kuni ozdan oldi» ni ajratadi. */
    docCount: z.number().int(),
});
/**
 * Rasxodning UCHALASI — jadvalda bitta raqamga yopishgan.
 *
 * «Hisobdan chiqdi» uchta boshqa-boshqa voqea bo'lishi mumkin va
 * rahbar uchun ular bir xil emas: ishlatib tugatilgani — normal ish,
 * omborga qaytarilgani — ortiqcha olingan degani, boshqa bo'linmaga
 * berilgani esa umuman yo'qotish emas.
 */
export const FLOW_OUT_KINDS = ['WRITE_OFF', 'RETURN', 'TRANSFER_OUT'];
export const flowOutKindSchema = z.enum(FLOW_OUT_KINDS);
export const flowOutSplitSchema = z.object({
    kind: flowOutKindSchema,
    docCount: z.number().int(),
});
/**
 * QR BILAN OLISH — `stock_usage` jurnalining bitta satri.
 *
 * Mobil ilovada xodim etiketkani skanerlaydi va «oldim» deydi. Mol
 * hisobdan chiqmaydi: javondan ketadi, hisobda qoladi va keyinchalik
 * rasxod aktida ko'rinadi.
 */
export const flowUsageRowSchema = z.object({
    id: z.string(),
    workerName: z.string(),
    /** Lavozim — «Elektrik». Kadrlarda yozilmagan bo'lishi mumkin. */
    position: z.string().nullable(),
    nomenclatureName: z.string(),
    unit: z.string(),
    qty: z.number(),
    storeroomName: z.string().nullable(),
    /** Nima uchun olingani — mobil ilovada majburiy maydon. */
    comment: z.string(),
    usedAt: z.string(),
});
/**
 * HUJJAT — davr ichidagi kirim yoki rasxod.
 *
 * Raqami bor hujjatning raqami ko'rsatiladi (talabnoma, rasxod akti);
 * boshlang'ich qoldiq kabi raqamsiz hujjat o'z turi bilan qoladi.
 */
export const flowDocRowSchema = z.object({
    docType: z.string(),
    docId: z.string(),
    docNo: z.string().nullable(),
    direction: z.enum(['IN', 'OUT']),
    at: z.string(),
    /** Hujjatdagi jurnal satrlari soni — «3 xil mahsulot» degani. */
    lineCount: z.number().int(),
});
export const flowDetailSchema = z.object({
    level: flowLevelSchema,
    id: z.string(),
    name: z.string(),
    code: z.string().nullable(),
    /** Jadvaldagi satrning raqamlari bilan AYNI manbadan. */
    totals: flowTotalsSchema,
    outSplit: z.array(flowOutSplitSchema),
    topIn: z.array(flowProductSchema),
    topOut: z.array(flowProductSchema),
    usage: z.array(flowUsageRowSchema),
    /** Jami QR yozuvi — ro'yxat qisqartirilgani bilinib turishi uchun. */
    usageTotal: z.number().int(),
    docs: z.array(flowDocRowSchema),
    docTotal: z.number().int(),
});
//# sourceMappingURL=flow-detail.schema.js.map